import { jsx as _jsx } from "react/jsx-runtime";
import { isNonNaNNumber } from '@iotv/iotv-v3-types';
import { getRangeColor } from '../../../NetworkCoverage/Display/metricRanges';
export const signalAttributeColor = (p) => {
    const v = p.formattedValue;
    const k = p.field;
    return SignalAttributeCell(k, v);
};
export const SignalAttributeCell = (attribute, value) => {
    const { fillColor, textColor } = getRangeColor(attribute, value);
    const color = textColor === 'inherit' ? `contrast-color(${fillColor})` : textColor;
    return _jsx("div", { style: { backgroundColor: fillColor, color, fontVariantNumeric: 'tabular-nums' }, children: isNonNaNNumber(value) ? value : '-' });
};
